import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL


export function getSolicitudTipo(product:any) {
    return axios.get(API_URL+'/v1/support/list_solicitud?type=Change Request&product='+product)
  }

export function getSolicitudTipoProblem(product:any) {
    return axios.get(API_URL+'/v1/support/list_solicitud?type=Incident Report&product='+product)
  }

export function getSolicitudTipoFeature() {
    return axios.get(API_URL+'/v1/support/list_solicitud?type=Feature Request')
  }